const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const handleResponse = async (response) => {
  if (!response.ok) {
    let message = 'Ocurrió un error en la solicitud.';
    try {
      const error = await response.json();
      message = error.message || message;
    } catch (_) {
      // sin cuerpo JSON
    }
    throw new Error(message);
  }
  return response.json();
};

// Genera/regenera el consolidado mensual de uno o varios centros (mes cerrado).
export const generateMonthlySummary = async ({ laundryIds, year, month, generadoPor } = {}) => {
  const response = await fetch(`${API_URL}/monthly-summaries/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ laundryIds, year, month, generadoPor }),
  });
  return handleResponse(response);
};

// Lista cortes existentes (gestión). Filtros opcionales.
export const listMonthlySummaries = async ({ laundryId, yearFrom, yearTo } = {}) => {
  const params = new URLSearchParams();
  if (laundryId) params.set('laundryId', laundryId);
  if (yearFrom) params.set('yearFrom', String(yearFrom));
  if (yearTo) params.set('yearTo', String(yearTo));
  const qs = params.toString();
  const response = await fetch(`${API_URL}/monthly-summaries${qs ? `?${qs}` : ''}`);
  return handleResponse(response);
};

// Comparativo entre lavanderías para un rango de períodos (YYYY-MM).
export const compareMonthlySummaries = async ({ from, to, laundryIds } = {}) => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (Array.isArray(laundryIds) && laundryIds.length > 0) {
    params.set('laundryIds', laundryIds.join(','));
  }
  const response = await fetch(`${API_URL}/monthly-summaries/compare?${params.toString()}`);
  return handleResponse(response);
};

// Elimina un corte por _id (para corregir y regenerar).
export const deleteMonthlySummary = async (id) => {
  const response = await fetch(`${API_URL}/monthly-summaries/${id}`, {
    method: 'DELETE',
  });
  return handleResponse(response);
};
